<header class="border-bottom shadow-sm mb-4">
  <nav class="navbar navbar-expand-lg navbar-light bg-light fixed-top">
    <a class="navbar-brand" href="https://start.efs-ag.com">EFS IT-World</a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbar"
      aria-controls="navbar" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbar">

      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <a class="nav-link hidden" href="#">
            {{ translation?.contact_support }}
          </a>
        </li>
      </ul>



      <ul class="navbar-nav d-flex align-items-center justify-content-center" *ngIf="userData">

        <li class="nav-item me-2">
          <a class="nav-link text-smaller link" (click)="openHRPopup()">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="icon icon-tabler icons-tabler-outline icon-tabler-users-group me-2">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M10 13a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
              <path d="M8 21v-1a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v1" />
              <path d="M15 5a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
              <path d="M17 10h2a2 2 0 0 1 2 2v1" />
              <path d="M5 5a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
              <path d="M3 13v-1a2 2 0 0 1 2 -2h2" />
            </svg>
            <span style="vertical-align: middle;">{{ translation?.contact_hr }}</span>
          </a>
        </li>

        <li class="nav-item me-2">
          <a class="nav-link text-smaller link" (click)="openContractPopup()">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="icon icon-tabler icons-tabler-outline icon-tabler-contract me-2">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M8 21h-2a3 3 0 0 1 -3 -3v-1h5.5" />
              <path d="M17 8.5v-3.5a2 2 0 1 1 2 2h-2" />
              <path d="M19 3h-11a3 3 0 0 0 -3 3v11" />
              <path d="M9 7h4" />
              <path d="M9 11h4" />
              <path d="M18.42 12.61a2.1 2.1 0 0 1 2.97 2.97l-6.39 6.42h-3v-3z" />
            </svg>
            <span style="vertical-align: middle;">{{ translation?.contact_contract }}</span>
          </a>
        </li>

        <li class="nav-item me-2">
          <a class="nav-link text-smaller link" (click)="openSupportPopup()">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="icon icon-tabler icons-tabler-outline icon-tabler-message-2-question me-2">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M8 9h8" />
              <path d="M8 13h6" />
              <path d="M14.5 18.5l-2.5 2.5l-3 -3h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v4.5" />
              <path d="M19 22v.01" />
              <path d="M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483" />
            </svg>
            <span style="vertical-align: middle;">{{ translation?.contact_support }}</span>
          </a>
        </li>

        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle pt-0 pb-0" href="#" role="button" data-bs-toggle="dropdown"
            aria-expanded="false">
            <span class="user-initials" *ngIf="!myAvatar">{{ userData.given_name?.charAt(0) }}{{
              userData.family_name?.charAt(0) }}</span>
            <img class="user-avatar" *ngIf="myAvatar" [src]="'data:image/jpeg;base64,' + myAvatar" alt="Avatar">
          </a>
          <ul class="dropdown-menu dropdown-menu-end">
            <li><a class="dropdown-item" href="https://auth.efs-ag.services/Manage/ChangePassword" target="_blank">{{
                translation?.change_password }}</a></li>
            <li><a class="dropdown-item" href="https://auth.efs-ag.services/Manage/Autoresponder" target="_blank">{{
                translation?.autoresponder }}</a></li>
            <li><a class="dropdown-item" href="https://auth.efs-ag.services/Manage/TwoFactorAuthentication"
                target="_blank">{{ translation?.two_factor_authentication }}</a></li>
            <li>
              <hr class="dropdown-divider">
            </li>
            <li><a class="dropdown-item link" (click)="logout()">{{ translation?.logout }}</a></li>
          </ul>
        </li>
      </ul>
    </div>
  </nav>
</header>

<div class="newsbanner hidden" *ngIf="unreadCount > 0">
  <div class="text">
    <svg height="40" width="40" class="dot">
      <circle cx="22" cy="17" r="5" fill="#1f2c50" />
    </svg> <a href="#news">Es gibt {{ unreadCount }} ungelesene EFSnews!</a>
  </div>
</div>